import script from "./PCPartsDetailsCardArticles.vue?vue&type=script&setup=true&lang=js"
export * from "./PCPartsDetailsCardArticles.vue?vue&type=script&setup=true&lang=js"

import "./PCPartsDetailsCardArticles.vue?vue&type=style&index=0&id=d9ebf56a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9ebf56a"]])

export default __exports__